/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import {
  Canvas, Circle, Group, Path, Skia, Text as SkiaText,
  Line,
  useFont,
} from '@shopify/react-native-skia';
import { Dimensions, Text, View } from 'react-native';
import { useState } from 'react';
import { useDerivedValue, useSharedValue, withTiming } from 'react-native-reanimated';
import { FontAwesome } from '@expo/vector-icons';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
import PressableStyled from '../components/PressableStyled';
import Colors from '../constants/Colors';
import Switch from '../components/Switch';

export default function GraphPrototype() {
  const graphs = [[{ x: 0, y: 20 }, { x: 10, y: 5 }, { x: 20, y: 10 }, { x: 30, y: 20 },
    { x: 40, y: 20 }, { x: 50, y: 10 }, { x: 60, y: 5 }, { x: 70, y: 20 },
  ], [{ x: 5, y: 20 }, { x: 10, y: 20 }, { x: 20, y: 10 }, { x: 30, y: 18 },
    { x: 40, y: 15 }, { x: 50, y: 20 }, { x: 60, y: 15 }, { x: 70, y: 20 },
  ]];

  const [graphSelected, setGraphSelected] = useState(0);
  const [darkTheme, setdarkTheme] = useState(true);
  const selectedGraphIndex = useSharedValue(0);
  const [compare, setCompare] = useState(false);
  const { width, height } = Dimensions.get('window');
  const transition = useSharedValue(0);

  const path = useDerivedValue(() => {
    const newPath = Skia.Path.Make();
    const oldPath = Skia.Path.Make();
    const graph = graphs[selectedGraphIndex.value];
    const oldGraph = graphs[selectedGraphIndex.value === 0 ? 1 : 0];
    newPath.moveTo(graph[0].x, (graph[0].y / 20) * (width / 2));
    graph.forEach((point) => newPath.lineTo((point.x / 70)
      * (width - 48), (point.y / 20) * (width / 2)));
    oldPath.moveTo(oldGraph[0].x, (oldGraph[0].y / 20) * (width / 2));
    oldGraph.forEach((point) => oldPath.lineTo((point.x / 70)
      * (width - 48), (point.y / 20) * (width / 2)));
    if (!transition.value) return newPath;
    return newPath.interpolate(oldPath, transition.value);
  }, [selectedGraphIndex.value, transition.value]);

  const path2 = useDerivedValue(() => {
    const newPath = Skia.Path.Make();
    const oldPath = Skia.Path.Make();
    const graph = graphs[selectedGraphIndex.value === 0 ? 1 : 0];
    const oldGraph = graphs[selectedGraphIndex.value === 0 ? 0 : 1];
    newPath.moveTo(graph[0].x, (graph[0].y / 20) * (width / 2));
    graph.forEach((point) => newPath.lineTo((point.x / 70)
      * (width - 48), (point.y / 20) * (width / 2)));
    oldPath.moveTo(oldGraph[0].x, (oldGraph[0].y / 20) * (width / 2));
    oldGraph.forEach((point) => oldPath.lineTo((point.x / 70)
      * (width - 48), (point.y / 20) * (width / 2)));
    return newPath.interpolate(oldPath, transition.value);
  }, [selectedGraphIndex.value, transition.value]);

  const x = useSharedValue(0);
  const y = useSharedValue(0);
  const tooltipY = useSharedValue(0);
  const tooltipX = useSharedValue(0);

  const currentPoint = useDerivedValue(() => `${20 - graphs[selectedGraphIndex.value][Math.round(x.value / 50)].y}`, [x.value]);
  // eslint-disable-next-line global-require
  const fontType = useFont(require('../assets/fonts/Roboto-Regular.ttf'), 24);
  // eslint-disable-next-line global-require
  const axisFontType = useFont(require('../assets/fonts/Roboto-Regular.ttf'), 14);

  const touchGesture = Gesture.Pan()
    .onStart((event) => {
      x.value = event.x;
    })
    .onUpdate((event) => {
      tooltipX.value = event.x;
      x.value = event.x;
      y.value = event.y;
    })
    .onEnd(() => {
      tooltipX.value = withTiming((graphs[selectedGraphIndex.value][Math.round(x.value / 50)].x / 70) * (width - 48) - (currentPoint.value.length * 7));
      tooltipY.value = withTiming((graphs[selectedGraphIndex.value][Math.round(x.value / 50)].y / 20) * (width / 2) - 15);
      y.value = withTiming((graphs[selectedGraphIndex.value][Math.round(x.value / 50)].y / 20) * (width / 2));
      x.value = withTiming((graphs[selectedGraphIndex.value][Math.round(x.value / 50)].x / 70) * (width - 48));
    });

  const transform = useDerivedValue(() => [{ translateX: x.value },
    { translateY: y.value ?? 0 }], [x]);

  const tooltipTransform = useDerivedValue(() => [{ translateX: tooltipX.value },
    { translateY: tooltipY.value ?? 0 }], [x]);

  return <View style={{ flex: 1, padding: 24, backgroundColor: darkTheme ? '#123' : Colors.light.hereworksBackground }}>
    <Text style={{
      fontFamily: 'Poppins_500Medium', color: darkTheme ? '#fff' : '#000', marginBottom: 50, fontSize: 20,
    }}>Graph Prototype</Text>
    <GestureDetector gesture={touchGesture}>
      <Canvas style={{
        width: '100%', height: height * 0.6, backgroundColor: 'transparent',
      }}>
        <SkiaText transform={tooltipTransform} text={currentPoint} font={fontType} color={darkTheme ? '#fff' : '#000'} />
        <SkiaText x={0} y={width / 2 + 24} text={'0'} font={axisFontType} color={darkTheme ? '#fff' : '#000'} />
        <Path style={'stroke'} path={path} strokeWidth={4} color={Colors.light.hereworksBlue200} />
        {compare ? <Path style={'stroke'} path={path2} strokeWidth={4} color={Colors.light.hereworksYellow200} /> : null}
        <Line p1={{ x: 0, y: width / 2 }} p2={{ x: width, y: width / 2 }} color={'grey'} strokeWidth={2} />
        <Line p1={{ x: 1, y: width / 2 }} p2={{ x: 1, y: 0 }} color={'grey'} strokeWidth={2} />
        <Group transform={transform}>
          <Circle r={12} color={ darkTheme ? '#fff' : '#000'} opacity={0.3} />
          <Circle r={8} color={ darkTheme ? '#fff' : '#000'} opacity={0.5} />
          <Circle r={4} color={ darkTheme ? '#fff' : '#000'} />
        </Group>
      </Canvas>
    </GestureDetector>
    <View style={{ flexDirection: 'row' }}>
      <Text style={{ fontFamily: 'Poppins_500Medium', color: darkTheme ? '#fff' : '#000', marginBottom: 20 }}>Compare: </Text>
      <Switch toggled={compare} toggle={() => setCompare(!compare)} />
    </View>
    <View style={{ flexDirection: 'row' }}>
    <PressableStyled
      style={{
        borderWidth: 1, borderColor: darkTheme ? '#fff' : '#000', borderRadius: 8, backgroundColor: graphSelected === 0 ? '#fff' : 'grey',
      }}
      disabled={graphSelected === 0}
      maintainOpacityWhenDisabled
      onPress={() => {
        setGraphSelected(0);
        selectedGraphIndex.value = 0;
        transition.value = 0;
        transition.value = withTiming(1, { duration: 1000 });
        y.value = -100;
      }}>
      <Text style={{ color: graphSelected === 0 ? '#123' : darkTheme ? '#fff' : '#000', padding: 8 }}>Graph 1</Text>
    </PressableStyled>
    <PressableStyled
    disabled={graphSelected === 1}
    maintainOpacityWhenDisabled
    style={{
      borderWidth: 1, borderColor: darkTheme ? '#fff' : '#000', borderRadius: 8, marginLeft: 8, backgroundColor: graphSelected === 1 ? '#fff' : 'grey',
    }}
    onPress={() => {
      setGraphSelected(1);
      selectedGraphIndex.value = 1;
      transition.value = 0;
      transition.value = withTiming(1, { duration: 1000 });
      y.value = -100;
    }}>
      <Text style={{ color: graphSelected === 1 ? '#123' : darkTheme ? '#fff' : '#000', padding: 8 }}>Graph 2</Text>
    </PressableStyled>
    <View style={{ flex: 1, alignItems: 'flex-end' }}>
      <PressableStyled onPress={() => setdarkTheme(!darkTheme)}><FontAwesome size={40} color={darkTheme ? '#fff' : '#000'} name={darkTheme ? 'sun-o' : 'moon-o'} /></PressableStyled>
    </View>
    </View>
  </View>;
}
